import "@stimulus/polyfills";
import { Application } from "stimulus";

const application = Application.start();


import "./../css/_app.scss";
// import pageTransitions from './animations/transitions';
// import * as basicScroll from 'basicscroll'
import utils from "./utils";
import nav from "./nav";
import sliders from "./sliders";
import contact from "./contact";
import filters from "./filters";
import cookies from "./cookies";
import pagination from "./pagination";
import faq from "./faq";

import files from "./files";
import tabs from "./tabs";
import videos from "./videos";
import handleForms from "./forms";
import handleOfferForms from "./offer-form";
import layouts from "./layouts";
import hilightTitles from "./titles";

import Aoe from "./aoe";

export default class App {
  constructor() {
    this.initDev(); // tests and shit
    this.initBody(); // runs on initialize & after barba
  }

  initBody() {
	sliders();
    tabs();
    contact();
    filters();
    cookies();
    pagination();
    faq();
    files();
    videos();
    handleForms();
    handleOfferForms();
    layouts();
    hilightTitles();
    const aoe = new Aoe();
    aoe.init();
  }

  initCore() {
    // pageTransitions(); // barbaajs
    nav.hamburger();
    nav.mobileNav();
  }

  initDev() {
    utils.clone("[data-clone]");
  }
}

function LoadApp() {
  const app = new App();
  app.initCore(); // runs on initialize
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", LoadApp);
} else {
  LoadApp();
}
